// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-guideline{position:fixed;width:100vw;height:100vh;top:0;bottom:0;left:0;right:0;z-index:99999999999999;background-color:#fff;overflow:auto;-webkit-overflow-scrolling:touch}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
